import { render, staticRenderFns } from "./RouteCard.vue?vue&type=template&id=a5afbd20&scoped=true"
import script from "./RouteCard.vue?vue&type=script&lang=js"
export * from "./RouteCard.vue?vue&type=script&lang=js"
import style0 from "./RouteCard.vue?vue&type=style&index=0&id=a5afbd20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5afbd20",
  null
  
)

export default component.exports